import { AppBar, List, Switch, Toolbar } from "@mui/material";
import { useState } from "react";
import muiStyles, { BoldIcon, Search, SearchIconWrapper, StyledInputBase } from "./muiStyles";
import SearchIcon from '@mui/icons-material/Search';
import MenuItem from "./MenuItem";
import { useTranslation } from "react-i18next";
import SupportIcon from '@mui/icons-material/Support';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import MasterRouter from "../routersMaster";
import RecursiveTreeView from "./RecursiveTreeView";
import Config from "../Config";

const MasterSideMenu = ({ onToggle, pinned }) => {
    const { t } = useTranslation();

    const [filteredRouters, setFilteredRouters] = useState(MasterRouter);



    // Recursive function to filter the routers by title
    const filterRouters = (routers, filterText) => {
        return routers
            .map((router) => {
                if (router.items) {
                    // Recursively filter child items
                    const filteredItems = filterRouters(router.items, filterText);

                    // Only return groups that have matching children
                    if (filteredItems.length > 0 || t(router.title).toLowerCase().includes(filterText.toLowerCase())) {
                        return { ...router, items: filteredItems };
                    }
                } else if (t(router.title).toLowerCase().includes(filterText.toLowerCase())) {
                    // If it's not a group, directly check the title
                    return router;
                }
                return null;
            })
            .filter(Boolean); // Remove null values
    };

    const handleSearchChange = (event) => {
        const filterText = event.target.value;
        const filteredRouters = filterRouters(MasterRouter, filterText);
        console.log('Filtered Routers:', filteredRouters);
        setFilteredRouters(filteredRouters);
    };


    const classes = muiStyles();

    const onChange = (event) => {
        const filteredRouters = filterRouters(MasterRouter, "");
        setFilteredRouters(filteredRouters);
        onToggle && onToggle(event.target.checked);
    };


    return (
        <nav id="side-menu" className={`side-menu ${pinned ? 'expanded' : ''}`} style={{ height: '100vh' }}>
            <AppBar position="static" elevation={0} className={classes.appBar}>
                <Toolbar className={classes.toolBar} variant="regular">
                    <div className={classes.boldIcon}>
                        <BoldIcon url={Config.MenuIcon} />
                    </div>

                    <div className={classes.boldLabel}>
                        Yönetim Paneli
                    </div>
                    <Switch checked={pinned} onChange={onChange} size="small" />
                </Toolbar>

            </AppBar>
            {pinned && (<ul>
                <Search
                    sx={{
                        padding: "0px",
                        margin: "0px",
                        // Ensure the item is displayed correctly
                        '& .MuiTreeItem-label': {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between', // Space out the items
                        },
                    }}>
                    <SearchIconWrapper>
                        <SearchIcon />
                    </SearchIconWrapper>
                    <StyledInputBase
                        placeholder={t('label.search')}
                        inputProps={{ 'aria-label': 'search' }}
                        onChange={handleSearchChange}
                    />
                </Search>
            </ul>)}

            <List className={`${classes.menu} menu`}>
                <RecursiveTreeView routers={filteredRouters} />
            </List>
            <ul className={`${classes.help} help`}>
                <MenuItem to="/" value={t('menu.help')} icon={<SupportIcon />} />
            </ul>

            <ul className={`${classes.logout} logout`}>
                <MenuItem to="/logout" value={t('menu.logout')} icon={<PowerSettingsNewIcon />} />
            </ul>

        </nav>

    );

};

export default MasterSideMenu;